import React, {Component} from 'react';
import {STATIC_BUTTON_CONFIG} from "./static-button-config";

class StaticButtonArea extends Component {

    render() {
        let width = 0;
        if(STATIC_BUTTON_CONFIG){
            width = STATIC_BUTTON_CONFIG.length * 110
        }
        return (
            <div style={{width}}>
                {STATIC_BUTTON_CONFIG && STATIC_BUTTON_CONFIG.map((item,index) => {
                    let StaticButtonComponent = require(`./${item}/${item}.js`).default;
                    return <StaticButtonComponent dynamicParams={this.props.dynamicParams} key={index} style={{marginLeft: 20}} editor={window.ueditor}/>
                })}
            </div>
        );
    }

}

export default StaticButtonArea;